import { gmapApi } from "vue2-google-maps";

export const DENVERS_LOCATION = { lat: 39.7417997, lng: -104.9315673 };
export type CurrentPosition = {
  lat: number;
  lng: number;
};

export class LocationService {
  async getCurrentLocation(): Promise<CurrentPosition> {
    return new Promise(resolve => {
      window.navigator.geolocation.getCurrentPosition(
        x => {
          resolve({ lat: x.coords.latitude, lng: x.coords.longitude });
        },
        () => {
          resolve(DENVERS_LOCATION);
        }
      );
    });
  }

  async lookUpZip({ lat, lng }: CurrentPosition): Promise<string> {
    return new Promise(async (resolve, reject) => {
      const api = await this.googleApi();
      const geocoder = new api.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status !== api.maps.GeocoderStatus.OK) {
          reject(status);
        }

        const addressWithZips = results.filter(r => r.types.indexOf("postal_code") !== -1);
        resolve(addressWithZips[0].address_components.filter(a => a.types.indexOf("postal_code") !== -1)[0].short_name);
      });
    });
  }

  async googleApi(): Promise<typeof google> {
    return new Promise(resolve => {
      const i = setInterval(() => {
        const api = gmapApi();
        if (api != null) {
          clearInterval(i);
          resolve(api);
        }
      }, 100);
    });
  }

  async getPositionForZip(zip: string): Promise<CurrentPosition> {
    return new Promise(async (resolve, reject) => {
      const api = await this.googleApi();
      const geocoder = new api.maps.Geocoder();
      geocoder.geocode({ address: zip }, (results, status) => {
        if (status !== api.maps.GeocoderStatus.OK) {
          reject(status);
          return;
        }

        const { location } = results[0].geometry;
        resolve({ lat: location.lat(), lng: location.lng() });
      });
    });
  }
}
